import { createAction } from 'redux-actions';
import viasportBackend from '../service/viasportBackend';

export default createAction('UPDATE_SELECTED_TEMPLATES', async () => {
  const selectedTemplates = await viasportBackend.getSelectedTemplates();
  return {selectedTemplates};
});



// WEBPACK FOOTER //
// ./src/action/loadSelectedTemplates.js